import { abweisen, istAnsprachform, type Ansprachform } from "../gemeinsam/index.js";

/** Revierregeln mit Voreinstellung (Domänenmodell §4, revier/03). Feldnamen = Regelnamen der Feature Files. */
export interface Revierregeln {
  Ansprachform: Ansprachform;
  "Zugang nach Abschluss einer Drückjagd": string;
  "Anonymisierung personenbezogener Details": string;
  "Erlegerregel bei Fangschuss": "Erstschütze" | "Fangschütze";
}

export const REGELN = ["Ansprachform", "Zugang nach Abschluss einer Drückjagd", "Anonymisierung personenbezogener Details",
  "Erlegerregel bei Fangschuss"] as const;

export const VOREINSTELLUNG: Revierregeln = {
  Ansprachform: "Du",
  "Zugang nach Abschluss einer Drückjagd": "30 Tage",
  "Anonymisierung personenbezogener Details": "Ende des Jagdjahres plus ein Jahr",
  "Erlegerregel bei Fangschuss": "Erstschütze",
};

export function ansprachformPruefen(wert: unknown): Ansprachform {
  if (!istAnsprachform(wert)) abweisen("ansprachform-ungueltig");
  return wert;
}

const FRIST_TAGE = /^(\d{1,3}) Tage$/;
const FRIST_JAGDJAHR = /^Ende des Jagdjahres plus (ein|zwei|drei|[1-3]) (Jahr|Jahre)$/;

/** Prüft geänderte Regeln; Gründe `ansprachform-ungueltig`, `frist-ungueltig`, `erlegerregel-ungueltig` (revier/03). */
export function regelnPruefen(aenderung: Partial<Record<string, unknown>>): Partial<Revierregeln> {
  const aus: Partial<Revierregeln> = {};
  if ("Ansprachform" in aenderung) aus.Ansprachform = ansprachformPruefen(aenderung["Ansprachform"]);
  const zugang = aenderung["Zugang nach Abschluss einer Drückjagd"];
  if (zugang !== undefined) {
    const m = typeof zugang === "string" ? FRIST_TAGE.exec(zugang) : null;
    if (!m || Number(m[1]) < 1 || Number(m[1]) > 365) abweisen("frist-ungueltig");
    aus["Zugang nach Abschluss einer Drückjagd"] = zugang as string;
  }
  const anon = aenderung["Anonymisierung personenbezogener Details"];
  if (anon !== undefined) {
    if (typeof anon !== "string" || !FRIST_JAGDJAHR.test(anon)) abweisen("frist-ungueltig");
    aus["Anonymisierung personenbezogener Details"] = anon;
  }
  const regel = aenderung["Erlegerregel bei Fangschuss"];
  if (regel !== undefined) {
    if (regel !== "Erstschütze" && regel !== "Fangschütze") abweisen("erlegerregel-ungueltig");
    aus["Erlegerregel bei Fangschuss"] = regel;
  }
  return aus;
}
